import { render, staticRenderFns } from "./ArtistSelectArtist.vue?vue&type=template&id=55a35b78&"
import script from "./ArtistSelectArtist.vue?vue&type=script&lang=js&"
export * from "./ArtistSelectArtist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports